<template>
  <el-select
    v-model="value"
    :size="selectSize"
    clearable
    filterable
    :placeholder="defaultPlaceholder"
    @change="updateValue"
    class="filterableSelect"
  >
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    >
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: "FilterableSelect",
  props: {
    inheritedOptions: {
      type: Array[
        {
          value: String,
          label: String
        }
      ],
      default: () => [
        {
          value: "",
          label: ""
        }
      ]
    },
    defaultPlaceholder: {
      type: String,
      default: "Select"
    },
    defaultValue: {
      type: String,
      default: ""
    },
    selectSize: {
      type: String,
      default: "mini"
    }
  },
  emits: ["updateValue"],
  data() {
    return {
      options: [
        {
          value: "",
          label: ""
        }
      ],
      value: ""
    };
  },
  computed: {
    newValue() {
      return this.defaultValue;
    },
    newOptions() {
      return this.inheritedOptions.map((option) => {
        return {
          value: option.value,
          label: option.label
        };
      });
    }
  },
  created() {
    this.value = this.newValue;
    this.options = this.newOptions;
  },
  watch: {
    defaultValue: {
      immediate: true,
      handler(newValue) {
        this.value = newValue;
      }
    }
  },
  methods: {
    updateValue(value) {
      this.value = value;
      this.$emit("updateValue", value);
    }
  }
};
</script>

<style scoped>
.filterableSelect {
  width: 100%;
}
</style>
